const selectors = {
  ARTICLE_TAB_HEADER_SELECTOR: '.js-article-tab-header',
  ARTICLE_TAB_CONTENT_SELECTOR: '.js-article-tab-content',
  ARTICLE_ACCORDION_HEADER_SELECTOR: '.js-accordion-header',
  ARTICLE_ACCORDION_CONTENT_SELECTOR: '.js-accordion-content',
  ARTICLE_ACCORDION_WRAPPER_SELECTOR: '.js-accordion-wrapper',
  OPEN_CLASS: 'is-open',
  ACTIVE_CLASS: 'is-active',
  HIDDEN_CLASS: 'hidden'
}

class ArticleTab extends HTMLElement {
  constructor() {
    super();

    this.tabHeaderEls = this.querySelectorAll(selectors.ARTICLE_TAB_HEADER_SELECTOR)
    this.tabContentEls = this.querySelectorAll(selectors.ARTICLE_TAB_CONTENT_SELECTOR)
  }

  connectedCallback() {
    if (this.tabHeaderEls.length > 0) {
      this.tabHeaderEls.forEach((tabHeader) => {
        tabHeader.addEventListener('click', this.activeTab.bind(this))
      })
    }
  }

  activeTab(e) {
    const currentIndex = e.target.dataset.index
    const currentContent = this.querySelector(`.js-article-tab-content[data-index="${currentIndex}"]`)

    this.addClassHidden(this.tabContentEls, selectors.HIDDEN_CLASS)
    this.removeClassActive(this.tabHeaderEls, selectors.ACTIVE_CLASS)
    e.target.classList.add(selectors.ACTIVE_CLASS)
    currentContent && currentContent.classList.remove(selectors.HIDDEN_CLASS)
  }

  removeClassActive(items, activeClass) {
    if (!items.length) return

    items.forEach((item) => {
      item.classList.remove(activeClass)
    })
  }

  addClassHidden(items, hiddenClass) {
    if (!items.length) return

    items.forEach((item) => {
      item.classList.add(hiddenClass)
    })
  }
}

if (!customElements.get("article-tab")) {
  customElements.define("article-tab", ArticleTab);
}

class ArticleAccordion extends HTMLElement {
  constructor() {
    super();

    this.accordionHeaderEls = this.querySelectorAll(selectors.ARTICLE_ACCORDION_HEADER_SELECTOR)
    this.accordionContentEls = this.querySelectorAll(selectors.ARTICLE_ACCORDION_CONTENT_SELECTOR)
  }

  connectedCallback() {
    if (this.accordionHeaderEls.length > 0) {
      this.accordionHeaderEls.forEach((accordionHeader) => {
        accordionHeader.addEventListener('click', this.toggleAccordion.bind(this))
      })
    }

    this.firstContentOpen()
  }

  firstContentOpen() {
    const currentContentWrapper = this.accordionContentEls[0].querySelector(selectors.ARTICLE_ACCORDION_WRAPPER_SELECTOR)
    const heightAccordionContent = currentContentWrapper.clientHeight

    this.accordionContentEls[0].style.height = heightAccordionContent + 'px'
  }

  toggleAccordion(e) {
    const currentTarget = e.target
    const currentIndex = e.target.dataset.index

    if (!currentTarget) return

    const currentContent = this.querySelector(`.js-accordion-content[data-index="${currentIndex}"]`)
    const currentContentWrapper = currentContent.querySelector(selectors.ARTICLE_ACCORDION_WRAPPER_SELECTOR)
    const heightAccordionContent = currentContentWrapper.clientHeight

    if (currentTarget.classList.contains(selectors.OPEN_CLASS)) {
      currentTarget.classList.remove(selectors.OPEN_CLASS)
      currentContent.style.height = 0 + 'px'
    } else {
      this.removeClassOpen(this.accordionHeaderEls, selectors.OPEN_CLASS)
      this.closeAllAccordion(this.accordionContentEls)
      currentTarget.classList.add(selectors.OPEN_CLASS)
      currentContent.style.height = heightAccordionContent + 'px'
    }
  }

  removeClassOpen(items, openClass) {
    if (!items.length) return

    items.forEach((item) => {
      item.classList.remove(openClass)
    })
  }

  closeAllAccordion(items) {
    if (!items.length) return

    items.forEach((item) => {
      item.style.height = 0 + 'px'
    })
  }
}

if (!customElements.get("article-accordion")) {
  customElements.define("article-accordion", ArticleAccordion);
}
